/** 提现页 怎么还 弹窗 -按期还 灵活还  */
import { namespace } from 'vuex-class';
import {
  Popup,
} from 'vant';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getShowRateValue } from './until';

const style = require('./index.module.scss') as Dictionary;

const ApplyProductStore = namespace('applyProduct');

@Component({ name: 'RepayChoicePopUp' })
export default class RepayChoicePopUp extends Vue {
  @ApplyProductStore.Action $updateState!: (data: Dictionary) => void;

  @ApplyProductStore.State repayOnSchedule!: boolean;

  @Prop()
  private choiceContentData!: {
      name: string;
      rate: number;
      des: string;
      repayOnSchedule: boolean;
  }[];


  /** 弹窗显示 */
  private popShow = false;

  /** 初始化 tab 默认index */
  private get activeIndex() {
    /** 0 是按期还，1是灵活还 */
    return this.repayOnSchedule
      ? 0 : 1;
  }

  /** 关闭pop */
  private hidePopup() {
    this.popShow = false;
  }


  public showPopup(
    visible: boolean,
  ): void {
    this.$ubtModuleExposeNew('finance_loan_apply_repayModePopUp', {});
    this.popShow = visible;
  }

  /** tab切换 更新是否按期还款状态 */
  private tabClick(index: number) {
    /** 更新 是否按期还 数据 */
    this.$updateState({
      repayOnSchedule: this.choiceContentData[index].repayOnSchedule,
    });
    this.$ubtPageButtonNew('finance_loan_apply_repayModePopUp',
      { repayMode: this.choiceContentData[index].repayOnSchedule ? '按期还' : '灵活还' });
    this.hidePopup();
  }

  private render() {
    return (
      <div class={style.repayChoicePop}>
        <Popup
          position="bottom"
          class={style.popContent}
          v-model={this.popShow}
        >
          <div class={style.title}>
            请选择怎么还
            <span
              class={style.close}
              onClick={this.hidePopup.bind(this)}
            ></span>
          </div>
          <div class={style.tabs}>
            {this.choiceContentData.length > 0 && this.choiceContentData.map((item, index) => (
              <div
                class={[style.tab, index === this.activeIndex && style.activeTab]}
                onClick={this.tabClick.bind(this, index)}
              >
                <div class={style.tabTitle}>
                  {item.name}
                  {
                    item.repayOnSchedule && (
                      <span class={style.topIcon}>利率低</span>
                    )
                  }
                </div>
                <div class={style.tabDes}>{item.des}</div>
                <div class={style.tabRateDes}>综合年化利率(单利)</div>
                <div class={style.tabRate}>{getShowRateValue(item.rate)}%</div>
                {index === this.activeIndex && (
                  <span class={style.chooseIcon}></span>
                )}
              </div>
            ))}
          </div>
          <div class={style.repayRulesDes}>
            <div class={style.repayRulesTitle}>还款规则说明：</div>
            <div class={style.repayRulesContent}>
              <div class={style.repayRulesContentItem}>
                按期还款综合利率更低，每期按期还款均会活得一定金额的红包返现作为履约奖励<span>（逾期情况除外）</span>
              </div>
              <div class={style.repayRulesContentItem}>
                <span>按期还款不倡导提前结清，如用户发起提前结清，则需先偿还掉已发放的权益红包，之后可发起提前结清行为</span>
              </div>
              <div class={style.repayRulesContentItem}>
                建议您根据实际用款需求选择灵活还款方式
              </div>
            </div>
          </div>
        </Popup>
      </div>
    );
  }
}
